import { createSelector } from "reselect";
import { State } from "../type";
import { INotifierState } from "./reducer";

export function selectNotifierState(state: State): INotifierState {
    return state.notifier;
}

export const selectNotifications = createSelector(selectNotifierState, state => state.notifications);
